<template>
  <div>
    <ContatoModal ref="modalContato"/>
    <b-table
        :striped="true"
        :bordered="true"
        :hover="true"
        :responsive="true"
        table-variant="secondary"
        :fields="fields"
        :items="getContatos"
        :busy="$store.getters['PTC_CadastroClienteClient/getIsLoadingContatos']"
        show-empty
        empty-text="Nenhum registro encontrado"
    >
      <!-- A virtual column -->
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(clientecontatoseqerp)="data">
        <div class="text-nowrap">
          {{ data.item.clientecontatoseqerp }}
        </div>
      </template>

      <template #cell(clientecontatonome)="data">
        {{ data.item.clientecontatonome }}
      </template>

      <template #cell(clientecontatoemail)="data">
        {{ data.item.clientecontatoemail }}
      </template>

      <!-- <template #cell(clientecontatoprincipal)="data">
        <div>
          <b-form-checkbox
              :checked="data.item.clientecontatoprincipal"
              class="custom-control-success"
              name="check-button"
              switch
              inline
              disabled
          />
        </div>
      </template> -->

      <template #cell(clientecontatoprincipal)="data">
        <div class="text-nowrap">
          {{ data.item.clientecontatoprincipal ? 'Sim' : 'Não' }}
        </div>
      </template>

      <template #cell(action)="data">
        <div
            class="d-flex"
            style="gap:5px"
        >
          <b-button
              variant="success"
              size="sm"
              @click="abrirModal('visualizar', data.item)"
              :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges']"
          >
            <feather-icon icon="SearchIcon"/>
            <span>Visualisar</span>
          </b-button>
          <b-button
              variant="warning"
              size="sm"
              @click="abrirModal('atualizar', data.item)"
              :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
          >
            <feather-icon icon="EditIcon"/>
            <span>editar</span>
          </b-button>
          <b-button
              variant="danger"
              size="sm"
              @click="confirmText(data.item)"
              :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
          >
            <feather-icon icon="TrashIcon"/>
            <span>excluir</span>
          </b-button>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col>
        <b-button
            variant="gradient-primary"
            @click="abrirModal('adicionar')"
            :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
        >
          <span class="align-middle">Adicionar Contato</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BFormSelect } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import ContatoModal from '@/views/app/PTC/CadastroCliente/contato/contatoModal.vue';
import PTC_CadastroClienteService from '@/services/PTC/PTC_CadastroCliente.service';

const ptc_cadastroClienteService = new PTC_CadastroClienteService();
export default {
  components: {
    ContatoModal,
    BFormSelect,
  },
  data() {
    return {
      fields: [
        { key: 'clientecontatoseqerp', label: 'Seq.' },
        { key: 'clientecontatonome', label: 'Nome' },
        { key: 'clientecontatoemail', label: 'E-mail' },
        { key: 'clientecontatoprincipal', label: 'Contato Principal' },
        { key: 'action', label: 'Ações' },
      ],
    };
  },

  methods: {
    abrirModal(tipoOperacao, dados) {
      this.$refs.modalContato.abrirModal(tipoOperacao, dados);
    },
    confirmText(item) {
      this.$swal({
        title: 'Tem certeza?',
        text: 'Você não poderá reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteContato(item);
          // this.$swal({
          //   icon: 'success',
          //   title: 'Excluído!',
          //   text: 'O Cliente foi excluído com sucesso.',
          //   customClass: {
          //     confirmButton: 'btn btn-success',
          //   },
          // })
        }
      });
    },
    async deleteContato(item) {
      const { clienteid } = item;
      await ptc_cadastroClienteService.DeleteContato(clienteid, { clientecontatoseq: item.clientecontatoseq, clienteiderp: item.clienteiderp });
      await ptc_cadastroClienteService.RetornaContatos();
    },
  },
  computed: {
    ...mapGetters({
      getContatos: 'PTC_CadastroClienteClient/getContatos',
    }),
  },
};
</script>
<style scoped lang="scss">

</style>
